import { render } from "./TheVacansy.vue?vue&type=template&id=3031b555&scoped=true"
import script from "./TheVacansy.vue?vue&type=script&lang=js"
export * from "./TheVacansy.vue?vue&type=script&lang=js"

import "./TheVacansy.vue?vue&type=style&index=0&id=3031b555&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3031b555"]])

export default __exports__